export function parseWebUrl(url: string) {
    const groupValue = url.match(/^(([^:\/\s]+):\/?\/?([^\/\s@]*@)?([^\/@:]*)?:?(\d+)?)?(\/[^?]*)?(\?([^#]*))?(#[\s\S]*)?$/) as any[]
    const keyObjectParse: string[] = ['fullUrl', 'scheme', 'protocol', 'authority', 'host', 'port', 'path', '?query', 'query', 'fragment']
    const objectParser = {}
    keyObjectParse.forEach((item, index) => {
        objectParser[item] = groupValue[index]
    })
    return objectParser
}

export function validURL(str: string) {
    const pattern = new RegExp(
        '^(https?:\\/\\/)' + // protocol
        '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' + // domain name
        '((\\S+):(\\S+)@)?((\\d{1,3}\\.){3}\\d{1,3}))' + // OR ip (v4) address with Basic Auth
        '((\\:\\d+)?((\\/\\w+)*\\/)([\\w\\-\\.]+[^#?\\s]+)?)' + // path or port
        '(?:&?[^=&]*=[^=&]*)*' + // Query string
        '(#[\\w\\-]+)?', // Hash (tag)
        'i'); // fragment locator
    return !!pattern.test(str);
}
